import clientConfigApi from '../config/config'
import axios from 'axios';
//import { token } from '../config/constant';

export const fetchMovieList = (path, token) => {
  return async dispatch => {
    try {
      let { data = {} } = await clientConfigApi.post(
        path,
        {
          "header": {
            "sessionToken": token
          },
          "payload": {
            "videoType": "webApp"
          }
        }
      )
        .catch(
          (response) => {
            console.log("movies not fetched Api failed with the status code:", response);
          }
        )
      if (data && data.payload && data.payload.videoList) {
        //console.log("movies", data.payload);
        dispatch({
          type: 'Movie_List',
          payload: data.payload.videoList
        }
        );
      }
    } catch (e) {
      console.log("error in movie list api", e);
    }
  }
}